export const CommerceTypeDecorator = {
  url() {
    return `signup-hubspot/commerce`;
  },
  query() {
    return {};
  }
};